// GTM/Analytics tracking utilities

export const pushToDataLayer = (event: any) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push(event);
  }
};

export const trackEvent = (
  eventName: string,
  category?: string,
  label?: string,
  value?: number,
  customParams?: Record<string, any>
) => {
  pushToDataLayer({
    event: eventName,
    event_category: category,
    event_label: label,
    value: value,
    ...customParams,
  });
};

export const trackRegistrationComplete = (email?: string) => {
  trackEvent("registration_complete", "engagement", "user_registration", 1, {
    user_email: email || "",
    registration_timestamp: new Date().toISOString(),
  });
};

export const trackUserLogin = (userId?: string, email?: string) => {
  trackEvent("login", "engagement", "user_login", 1, {
    user_id: userId || "",
    user_email: email || "",
    login_timestamp: new Date().toISOString(),
  });
};

export const trackMeetingCreated = (
  meetingId?: string,
  meetingType?: string
) => {
  trackEvent("meeting_created", "engagement", "meeting_management", 1, {
    meeting_id: meetingId || "",
    meeting_type: meetingType || "",
    creation_timestamp: new Date().toISOString(),
  });
};

export const trackWorkspaceCreated = (workspaceId?: string) => {
  trackEvent("workspace_created", "engagement", "workspace_management", 1, {
    workspace_id: workspaceId || "",
    creation_timestamp: new Date().toISOString(),
  });
};

export const trackPageView = (pagePath: string, pageTitle?: string) => {
  pushToDataLayer({
    event: "page_view",
    page_path: pagePath,
    page_title: pageTitle || document.title,
    timestamp: new Date().toISOString(),
  });
};

export const trackTaskCreated = (taskId?: string, taskType?: string) => {
  trackEvent("task_created", "engagement", "task_management", 1, {
    task_id: taskId || "",
    task_type: taskType || "",
    creation_timestamp: new Date().toISOString(),
  });
};

export const trackVotingCreated = (votingId?: string) => {
  trackEvent("voting_created", "engagement", "voting_management", 1, {
    voting_id: votingId || "",
    creation_timestamp: new Date().toISOString(),
  });
};

export const trackUserInvited = (
  workspaceId?: string,
  invitedEmail?: string
) => {
  trackEvent("user_invited", "engagement", "user_management", 1, {
    workspace_id: workspaceId || "",
    invited_email: invitedEmail || "",
    invitation_timestamp: new Date().toISOString(),
  });
};

export const trackMeetingJoined = (meetingId?: string, joinType?: string) => {
  trackEvent("meeting_joined", "engagement", "meeting_participation", 1, {
    meeting_id: meetingId || "",
    join_type: joinType || "regular", // 'regular', 'guest', 'host'
    join_timestamp: new Date().toISOString(),
  });
};

export const trackDocumentDownload = (
  documentId?: string,
  documentType?: string
) => {
  trackEvent("document_download", "engagement", "document_management", 1, {
    document_id: documentId || "",
    document_type: documentType || "",
    download_timestamp: new Date().toISOString(),
  });
};

export const trackFeatureUsage = (featureName: string, action?: string) => {
  trackEvent("feature_usage", "engagement", "feature_interaction", 1, {
    feature_name: featureName,
    action: action || "used",
    usage_timestamp: new Date().toISOString(),
  });
};
